import * as React from 'react';
import { ActionBarItem, ButtonAction } from './ActionBarItem';
import { Styleable } from '../utils/styles';

const base = 'flex flex-row-ns flex-column items-center ma3 mh0-ns';

export { ActionBarItem, ButtonAction } from './ActionBarItem';

export interface ActionBarProps extends Styleable {
  actions: ButtonAction[];
}

export enum ActionBarStyle {
  alignLeft = 'justify-start',
  alignRight = 'justify-end',
  alignCenter = 'justify-center',
  stretch = 'justify-stretch',
  justify = 'justify-between',
}

export const ActionBar = (props: ActionBarProps) => (
  <div className={`${base} ${props.className}`}>
    {props.actions.map(ActionBarItem)}
  </div>
);
